exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".TagBar-default-YRTqJ{margin-bottom:15px}.TagBar-tagGroup-3E3LU{position:relative;display:block;margin:0 -15px;padding:0 15px;list-style-type:none}.TagBar-tagGroup-3E3LU>li{display:inline-block;width:25%;text-align:center;vertical-align:top}.TagBar-tagGroup-3E3LU>li button{display:block;width:100%;padding:0;font-size:14px;font-weight:400;white-space:normal;color:#8a959a}.TagBar-tagGroup-3E3LU>li button:hover{text-decoration:none}.TagBar-tagGroup-3E3LU>li button label{display:block;margin:0;min-height:40px}.TagBar-tagGroup-3E3LU>li button label:first-letter{text-transform:uppercase}", ""]);

// exports
exports.locals = {
	"default": "TagBar-default-YRTqJ",
	"tagGroup": "TagBar-tagGroup-3E3LU"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/core/components/TagBar.less
// module id = 1662
// module chunks = 0